module.exports = "/_next/static/images/bf5e31268f9b50404702a08e36b16927-pj-woman-working@1x.jpg.webp";